import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvolveVLogoAnimation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 751,
	height: 739,
	viewBox: "0 0 751 739",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "cut-off",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 60,
				width: 751,
				height: 700
			})
		}) }),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector 1",
			d: "M15.4189 8.27637L387.419 701.276L720.919 80.2762H643.419L387.419 556.276L133.419 80.2762H215.92L387.419 410.776L596.419 8.27637",
			stroke: "#FF5C00",
			strokeWidth: 35,
			className: "id_anim_stroke-property0",
			"data-duration": 5,
			"data-offset": 0,
			style: {
				strokeDashoffset: 3500,
				strokeDasharray: 3500,
				animation: "3s linear 0s infinite normal forwards running id_anim_stroke-property0"
			},
			clipPath: "url(#cut-off)"
		}),
		/* @__PURE__ */ _jsx("style", { children: "\n        @keyframes id_anim_stroke-property0{\n\n        100%{\n        stroke-dashoffset: -3500px;\n        stroke-dasharray: 3500px;\n        }\n\n\n        }\n    " })
	]
});
export default SvgEvolveVLogoAnimation;
